import { IImpact } from 'src/types'

import { ImpactCard } from './impact-card.component'
import { List } from './impact-cards-ver.styled'
import { useState } from 'react'
import { TitleSt } from 'src/pages/impacts/impacts.styled'
import { useTranslation } from 'react-i18next'

interface IProps {
  items: IImpact[]
  showUnSdg: boolean
  primaryColor: string
  walletAddress: string
  showWalletAddress: boolean
  showBcInfo: boolean
  showLatestBcOnImpacts: boolean
  accountImage: string
}

export const ImpactsCardsVer = ({
  items,
  showUnSdg,
  primaryColor,
  walletAddress,
  showWalletAddress,
  showBcInfo,
  showLatestBcOnImpacts,
  accountImage,
}: IProps) => {
  const [isMobile] = useState<boolean>(window.innerWidth < 770)
  const [t] = useTranslation()

  return (
    <>
      <TitleSt
        id="index__components-impacts-cards-ver__titlest__l33"
        sx={{ paddingTop: '50px' }}
        isMobile={isMobile}
        variant="h2"
      >
        {t('impacts-header-title')}
      </TitleSt>

      <List id="index__components-impacts-cards-ver__list__l37">
        {items.map((item) => (
          <ImpactCard
            unSdg={item.un_sdg}
            key={item.id}
            media={item.media}
            mainMedia={item.mainMedia}
            description={item.description}
            title={item.quantity}
            subtitle={item.name}
            image={item.image_medium || item.image}
            likes={item.totalLikes}
            liked={item.liked}
            impactId={item.id}
            quantityName={item.quantity_type_name || item.custom_quantity_type}
            showUnSdg={showUnSdg}
            scans={item.scans}
            primaryColor={primaryColor}
            walletAddress={walletAddress}
            showWalletAddress={showWalletAddress}
            showBcInfo={showBcInfo}
            showLatestBcOnImpacts={showLatestBcOnImpacts}
            accountImage={accountImage}
            aiGenerated={item.ai_generated}
            aiVerifiedCount={item?.consumerScanInfo?.count || 0}
            aiVerifiedInfo={item?.consumerScanInfo?.data || []}
          />
        ))}
      </List>
    </>
  )
}
